var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.5816 7.5816 4 12 4C16.4184 4 20 7.5816 20 12C20 16.4184 16.4184 20 12 20C7.5816 20 4 16.4184 4 12ZM14.9656 10.9656C15.1113 10.8147 15.192 10.6126 15.1901 10.4029C15.1883 10.1931 15.1042 9.99247 14.9559 9.84415C14.8075 9.69582 14.6069 9.61168 14.3971 9.60986C14.1874 9.60804 13.9853 9.68867 13.8344 9.8344L11.2 12.4688L10.1656 11.4344C10.0147 11.2887 9.81264 11.208 9.60288 11.2099C9.39312 11.2117 9.19247 11.2958 9.04415 11.4441C8.89582 11.5925 8.81168 11.7931 8.80986 12.0029C8.80804 12.2126 8.88867 12.4147 9.0344 12.5656L10.6344 14.1656C10.7844 14.3156 10.9879 14.3998 11.2 14.3998C11.4121 14.3998 11.6156 14.3156 11.7656 14.1656L14.9656 10.9656Z",
    fill: "#1ACC81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaded);
export default __webpack_public_path__ + "static/media/uploaded.d8fbd9929ba221baaf7f217fbe4fc005.svg";
export { ForwardRef as ReactComponent };